import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './Checkbox.less';

class Checkbox extends Component {
	componentDidMount() {
		if (this.props.indeterminate === true) {
			this._setIndeterminate(true);
		}
	}

	componentDidUpdate(previousProps) {
		if (!this.props.checked) {
			this._setIndeterminate(this.props.indeterminate);
		}
	}

	_setIndeterminate(indeterminate) {
		if (this.checkbox) {
			this.checkbox.indeterminate = indeterminate;
		}
	}

	render() {
		const {className, controlClassName, labelClassName, children, onLabelClick, indeterminate: _, ...props} = this.props;
		const {
			checkbox: checkboxClass,
			checkbox__control: controlClass,
			checkbox__label: labelClass
		} = styles;

		return (
			<label className={classNames(checkboxClass, className)} onClick={onLabelClick}>
				<div className={classNames(controlClass, controlClassName)}>
					<input ref={node => this.checkbox = node} type="checkbox" {...props} />
				</div>
				<div className={classNames(labelClass, labelClassName)}>
					{children}
				</div>
			</label>
		);
	}
}

Checkbox.propTypes = {
	onChange: PropTypes.any,
	checked: PropTypes.any,
	indeterminate: PropTypes.any,
};

export default Checkbox;